import { useCallback, useEffect, useState } from "react";
import api from "@/lib/api";

export function useClientGallery(eventId) {
  const [event, setEvent] = useState(null);
  const [photographer, setPhotographer] = useState(null);
  const [photos, setPhotos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const ev = await api.get(`/public/events/${eventId}`);
      setEvent(ev.data.event);
      setPhotographer(ev.data.photographer);
      const ph = await api.get(`/public/events/${eventId}/photos`);
      setPhotos(ph.data.photos);
    } catch { setError(true); }
    finally { setLoading(false); }
  }, [eventId]);

  useEffect(() => { load(); }, [load]);

  const patch = (id, changes) => setPhotos((prev) => prev.map((p) => (p.id === id ? { ...p, ...changes } : p)));

  const toggleSelect = async (photo) => {
    const val = !photo.selected;
    patch(photo.id, { selected: val });
    try { await api.post(`/public/events/${eventId}/photos/${photo.id}/select`, { selected: val }); }
    catch { patch(photo.id, { selected: !val }); }
  };

  const toggleFavorite = async (photo) => {
    const val = !photo.favorite;
    patch(photo.id, { favorite: val });
    try { await api.post(`/public/events/${eventId}/photos/${photo.id}/favorite`, { favorite: val }); }
    catch { patch(photo.id, { favorite: !val }); }
  };

  const submit = async (comments = "") => {
    setSubmitting(true);
    try {
      const { data } = await api.post(`/public/events/${eventId}/submit`, { comments });
      return data;
    } finally { setSubmitting(false); }
  };

  const selectedCount = photos.filter((p) => p.selected).length;

  return { event, photographer, photos, setPhotos, loading, error, toggleSelect, toggleFavorite, submit, submitting, selectedCount, reload: load };
}
